import { render } from "./ContactUsLink.vue?vue&type=template&id=62dbae3b&scoped=true&ts=true&lang=pug"
import script from "./ContactUsLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactUsLink.vue?vue&type=script&lang=ts&setup=true"

import "./ContactUsLink.vue?vue&type=style&index=0&id=62dbae3b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dbae3b"]])

export default __exports__